module.exports = __webpack_public_path__ + "SC05.6b271b89.png";